import { Pipe, PipeTransform } from '@angular/core';
import { HelperService } from '../../services/helper.service';

@Pipe({
  name: 'addFr',
  standalone: true,
})
export class AddFrPipe implements PipeTransform {

  constructor(
    private HELPER: HelperService,
  ) {
  }

  transform(url: string, skip = false): string {

    if (!url) return url;

    const urlRegex = /https?:\/\/[^\/]*iasplus[^\/]*\/[^\s"]+/g;

    if (!skip && url.match(urlRegex)) {
      return this.replaceLink(url, urlRegex);
    }

    return skip ? url : `${this.HELPER.frLoc}/${url || ''}`;
  }


  replaceLink(url: string, urlRegex: any): string {
    return url.replace(urlRegex, (url: string) => {
      return this.HELPER.convertLink(url, true);
    });
  }

}
